import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-241c517b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title w-100" }
const _hoisted_4 = { class: "d-flex justify-content-between align-items-center w-100" }
const _hoisted_5 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semobold mb-8" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = {
  class: "nav-link text-active-primary pb-4 active",
  "data-bs-toggle": "tab",
  href: "#"
}
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "tag-section mb-6" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between align-items-center mb-4" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "section-title" }, "Party")
], -1))
const _hoisted_11 = {
  key: 0,
  style: {"height":"200px"},
  class: "d-flex align-items-center justify-content-center"
}
const _hoisted_12 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_13 = {
  key: 2,
  class: "tags-grid"
}
const _hoisted_14 = { class: "tag-text" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "tag-section" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between align-items-center mb-4" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "section-title" }, "Account")
], -1))
const _hoisted_20 = {
  key: 0,
  style: {"height":"200px"},
  class: "d-flex align-items-center justify-content-center"
}
const _hoisted_21 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_22 = {
  key: 2,
  class: "tags-grid"
}
const _hoisted_23 = { class: "tag-text" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "dialog-footer" }

import { ref, onMounted } from "vue";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import SystemService from "../services/SystemService";

interface Tag {
  id: number;
  type: string;
  name: string;
}

// Data

const __default__ = {
  name: "TagsManagement",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const partyTags = ref<Tag[]>([]);
const accountTags = ref<Tag[]>([]);
const isLoading = ref({
  party: false,
  account: false,
});

// Modal
const showModal = ref(false);
const modalMode = ref<"create" | "edit">("create");
const submitLoading = ref(false);
const tagForm = ref<{
  id?: number;
  type: string;
  name: string;
}>({
  type: "",
  name: "",
});

// Methods
const fetchTags = async (type: string) => {
  isLoading.value[type as keyof typeof isLoading.value] = true;
  try {
    const tags = await SystemService.getTagsByType(type);

    if (type === "party") {
      partyTags.value = tags;
    } else if (type === "account") {
      accountTags.value = tags;
    }
  } catch (error) {
    console.error(`Error fetching ${type} tags:`, error);
  } finally {
    isLoading.value[type as keyof typeof isLoading.value] = false;
  }
};

const openCreateModal = () => {
  modalMode.value = "create";
  tagForm.value = {
    type: "",
    name: "",
  };
  showModal.value = true;
};

const openEditModal = (tag: Tag) => {
  modalMode.value = "edit";
  tagForm.value = {
    id: tag.id,
    type: tag.type,
    name: tag.name,
  };
  showModal.value = true;
};

const submitTag = async () => {
  if (!tagForm.value.name || !tagForm.value.type) {
    return;
  }

  submitLoading.value = true;
  try {
    if (modalMode.value === "create") {
      await SystemService.addTagsByTypeAndName({
        type: tagForm.value.type,
        name: tagForm.value.name,
      });
      console.log("Creating tag:", tagForm.value);
    } else {
      // TODO: 实现编辑API
      // await TagService.updateTag(tagForm.value.id, tagForm.value);
      console.log("Updating tag:", tagForm.value);
    }

    showModal.value = false;
    // 重新获取数据
    await fetchTags(tagForm.value.type);
  } catch (error) {
    console.error("Error submitting tag:", error);
  } finally {
    submitLoading.value = false;
  }
};

// Lifecycle
onMounted(async () => {
  await Promise.all([fetchTags("party"), fetchTags("account")]);
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", _hoisted_6, [
              _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.$t("title.tags")), 1)
            ])
          ]),
          _createElementVNode("button", {
            class: "btn btn-primary btn-add-large ms-auto",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (openCreateModal()))
          }, _toDisplayString(_ctx.$t("title.createTag")), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        (isLoading.value.party)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(ScaleLoader)
            ]))
          : (partyTags.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t("tip.nodata")), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(partyTags.value, (tag) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: tag.id,
                    class: "tag-card"
                  }, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(tag.name), 1),
                    _createElementVNode("button", {
                      class: "tag-edit",
                      onClick: ($event: any) => (openEditModal(tag)),
                      title: "Edit"
                    }, _hoisted_17, 8, _hoisted_15)
                  ]))
                }), 128))
              ]))
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        (isLoading.value.account)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createVNode(ScaleLoader)
            ]))
          : (accountTags.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.$t("tip.nodata")), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accountTags.value, (tag) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: tag.id,
                    class: "tag-card"
                  }, [
                    _createElementVNode("span", _hoisted_23, _toDisplayString(tag.name), 1),
                    _createElementVNode("button", {
                      class: "tag-edit",
                      onClick: ($event: any) => (openEditModal(tag)),
                      title: "Edit"
                    }, _hoisted_26, 8, _hoisted_24)
                  ]))
                }), 128))
              ]))
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showModal).value = $event)),
      title: 
        modalMode.value === 'create' ? _ctx.$t('title.createTag') : _ctx.$t('title.editTag')
      ,
      width: "420px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_27, [
          _createVNode(_component_el_button, {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (showModal.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: submitTag,
            loading: submitLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.save")), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
          "label-width": "110px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.type')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: tagForm.value.type,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tagForm.value.type) = $event)),
                  placeholder: _ctx.$t('tip.selectType'),
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "Party",
                      value: "party"
                    }),
                    _createVNode(_component_el_option, {
                      label: "Account",
                      value: "account"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.tagName')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: tagForm.value.name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tagForm.value.name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})